import moment from "moment";
import { setToHTMLBody } from "../htmlBuilder/htmlHelpers";
import { buildMaterialHTML } from "../htmlBuilder/material";
import { BOMReportPage } from "../types";
import { getImageBase64 } from "./helpers";

export const generateMaterialPage = async ({ imageDimension, showBasicDetails = true, showDataSheet = true , data, ...rest }: BOMReportPage) => {
  let isWebBrowser: boolean = false;

  const apiBaseURL: string = process.env?.REACT_APP_API_BASE_URL ?? "";

  if (apiBaseURL) {
    isWebBrowser = true;
  }

  let shouldScale = showDataSheet && data?.datasheets?.length > 0;

  const builtHTMLPage = await buildMaterialHTML(data, showBasicDetails, showDataSheet, imageDimension);

  const footer = rest.showFooter
    ? `
   <div style="width:100%; display:flex; align-items:center; justify-content:flex-end; font-size:8px; padding-right:20px; margin-bottom: -12px; solid #ccc;">
       <a href="${
         rest.footerURL
       }" style="color:rgb(125, 125, 125); text-decoration:none;" >Generated using IEHUB on ${moment(
        new Date()
      ).format("ll")}</a>
   </div>
   `
    : ``;

  const materialHTMLPage = setToHTMLBody(
    builtHTMLPage,
    "",
    rest.onlyHTML ? footer : "",
  );

  if (rest.onlyHTML) {
    return materialHTMLPage;
  }

  if (isWebBrowser) {
    const downloadURL = await fetch(apiBaseURL + "html2pdf", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
      },
      body: JSON.stringify({
        html: materialHTMLPage,
        orientation: rest.orientation,
        paper_size: rest.paperSize,
        display_header_footer: true,
        scale: shouldScale ? 1 : 0.70,
        footer_template: footer,
        margin: {
            top: "20px",
            left: "16px",
            right: "16px",
            bottom: "16px"
        }
      }),
    })
      .then((res) => res.json())
      .then(async (res) => res.download_url);

    return getImageBase64(downloadURL).then((res) => res as string);
  } else {
    return JSON.stringify({
      html: materialHTMLPage,
      orientation: rest.orientation,
      paper_size: rest.paperSize,
      display_header_footer: true,
      scale: shouldScale ? 1 : 0.70,
      footer_template: footer,
      margin: {
        top: "20px",
        left: "16px",
        right: "16px",
        bottom: "16px"
    }
    });
  }
};
